"use client";

import React from "react";
import {
  Bar,
  Cell,
  ComposedChart,
  ResponsiveContainer,
  Scatter,
  Tooltip,
  XAxis,
  ZAxis,
} from "recharts";

import { BarColors, PowerBarChartProps } from "./PowerBarChartProps";
import PowerBarChartTooltip from "./PowerBarChartTooltip";
import { getBarColor } from "./utils";

const PowerBarChart = ({
  syncId = 0,
  data,
  theme,
  powerColors = ["transparent", "#D4D4D8", "#FCA5A5", "#F59E0B", "#EF4444"],
  showTooltipContent = false,
  showPowerDots = true,
  powerDotSize = 250,
}: PowerBarChartProps) => {
  if (!data.length) return <></>;

  if (showPowerDots)
    data = data.map((d) => ({ ...d, dot: 0, dotValue: powerDotSize }));

  let barColors: BarColors = {
    positiveAscColor: "#5eead4",
    positiveDescColor: "#14B8A6",
    negativeAscColor: "#BAE6FD",
    negativeDescColor: "#38BDF8",
  };

  if (theme === "surfing-trend")
    barColors = {
      positiveAscColor: "#5eead4",
      positiveDescColor: "#14B8A6 ",
      negativeAscColor: "#FCA5A5",
      negativeDescColor: "#EF4444",
    };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data} syncId={syncId} syncMethod="value">
        <Bar dataKey="value" isAnimationActive={false}>
          {data.map((entry, i) => (
            <Cell
              key={i}
              fill={getBarColor(
                barColors,
                entry.value,
                i > 0 ? data[i - 1].value : null
              )}
            />
          ))}
        </Bar>
        {showPowerDots && (
          <Scatter dataKey="dot" isAnimationActive={false}>
            {data.map((entry, i) => (
              <Cell key={i} fill={powerColors[entry.power]} />
            ))}
          </Scatter>
        )}
        <ZAxis
          type="number"
          dataKey="dotValue"
          domain={[0, powerDotSize]}
          range={[0, powerDotSize]}
        />
        <Tooltip
          content={showTooltipContent ? <PowerBarChartTooltip /> : <></>}
        />
        <XAxis dataKey="time" hide={true} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default React.memo(PowerBarChart);
